<template>
	<div class="text-right">
		<InfoBox>
			Diese Nachricht dient zur Info und setzt keinen Folgeschritt voraus. Markiere sie als gelesen, damit
			sie nicht mehr unter "Neue Nachrichten" angezeigt wird.
		</InfoBox>
		<Button
			text="Als gelesen markieren"
			:disabled="sendingRequest"
			:loading="sendingRequest"
			class="mt-3"
			@click="markAsRead"
		/>
	</div>
</template>

<script>
import Button from "@/vue/common/Button";
import InfoBox from "@/vue/common/InfoBox";
import Reply, {ACTION_MARK_AS_READ} from "@/api/communication/conversation/message/Reply";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";

export default {

	components: {
		Button,
		InfoBox,
	},

	props: {
		message: {
			type: Object,
			required: true,
		},
	},

	data ()
	{
		return {
			sendingRequest: false,
		};
	},

	methods: {
		async markAsRead ()
		{
			this.sendingRequest = true;

			try
			{
				await new Reply()
					.setMessageId(this.message.id)
					.setAction(ACTION_MARK_AS_READ)
					.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>